export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.id.description",//"Código interno",
          label: "wkt.admin.qbuilder.model.calendar.id.text",//"Código",
          field: "id"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.calendar.name.description",//"Nombre",
          label: "wkt.admin.qbuilder.model.calendar.name.text",//"Nombre",
          field: "name"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.calendar.description.description",//"Descripción",
          label: "wkt.admin.qbuilder.model.calendar.description.text",//"Descripción",
          field: "description"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.exercise_min.description",//"Ejercicio mínimo",
          label: "wkt.admin.qbuilder.model.calendar.exercise_min.text",//"Ejercicio mínimo",
          field: "exerciseMin"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.exercise_max.description",//"Ejercicio máximo",
          label: "wkt.admin.qbuilder.model.calendar.exercise_max.text",//"Ejercicio máximo",
          field: "exerciseMax"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.creator_id.description",//"Id de creador",
          label: "wkt.admin.qbuilder.model.calendar.creator_id.text",//"Id de creador",
          field: "creatorId"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.base_calendar_id.description",//"Id Calendario base",
          label: "wkt.admin.qbuilder.model.calendar.base_calendar_id.text",//"Id Calendario base",
          field: "baseCalendarId"
        },
        {
          type: "DATETIME",
          desc: "wkt.admin.qbuilder.model.calendar.creation_date.description",//"Fecha de creación",
          label: "wkt.admin.qbuilder.model.calendar.creation_date.text",//"Fecha de creación",
          field: "creationDate",
          formatter: 'formatDateTime'
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.calendar_mode.description",//"Modo calendario",
          label: "wkt.admin.qbuilder.model.calendar.calendar_mode.text",//"Modo calendario",
          field: "calendarMode"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.location_enable.description",//"Geolocalización habilitada",
          label: "wkt.admin.qbuilder.model.calendar.location_enable.text",//"Geolocalización habilitada",
          field: "locationEnable",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.confirm_location.description",//"Confirmar geolocalización",
          label: "wkt.admin.qbuilder.model.calendar.confirm_location.text",//"Confirmar geolocalización",
          field: "confirmLocation",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.confirm_activity.description",//"Confirmar actividad",
          label: "wkt.admin.qbuilder.model.calendar.confirm_activity.text",//"Confirmar actividad",
          field: "confirmActivity",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.mandatory_project.description",//"Proyecto obligatorio",
          label: "wkt.admin.qbuilder.model.calendar.mandatory_project.text",//"Proyecto obligatorio",
          field: "mandatoryProject",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.force_same_date_activities.description",//"Permitir actividades el día posterior a la jornada",
          label: "wkt.admin.qbuilder.model.calendar.force_same_date_activities.text",//"Permitir actividades el día posterior a la jornada",
          field: "forceSameDateActivities",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.calendar.assisted_check_in_use_actual_time.description",//"Indicar hora de inicio de check-in asistido",
          label: "wkt.admin.qbuilder.model.calendar.assisted_check_in_use_actual_time.text",//"Indicar hora de inicio de check-in asistido",
          field: "assistedCheckInUseActualTime",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.calendar.initials.description",//"Iniciales",
          label: "wkt.admin.qbuilder.model.calendar.initials.text",//"Iniciales",
          field: "initials"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.calendar.color.description",//"Color",
          label: "wkt.admin.qbuilder.model.calendar.color.text",//"Color",
          field: "color"
        },
      ],
}